import api from './client'

export interface Category {
  id: string
  name: string
  icon: string
  type: 'INCOME' | 'EXPENSE'
  monthlyLimit?: number | null
  /** For the financial year; never set together with monthlyLimit. */
  yearlyLimit?: number | null
  // Optional: the web app can deploy before the API that adds them. The two usage fields come only
  // with listCategories({ usage: true }).
  transactionCount?: number | null
  /** This calendar month: net spend for an expense category, income for an income one. */
  thisMonthTotal?: number | null
  /** Loans find it by name, so its name and type can't change. */
  locked?: boolean
}

export interface CategoryListResponse {
  categories: Category[]
}

export function listCategories(
  search?: string,
  options?: { usage?: boolean }
): Promise<CategoryListResponse> {
  return api
    .get('/categories', {
      params: { ...(search ? { search } : {}), ...(options?.usage ? { usage: true } : {}) },
    })
    .then((r) => r.data)
}

export function createCategory(payload: {
  name: string
  icon: string
  type: 'INCOME' | 'EXPENSE'
  monthlyLimit?: number | null
}): Promise<Category> {
  return api.post('/categories', payload).then((r) => r.data)
}

export function updateCategory(
  id: string,
  payload: {
    name?: string
    icon?: string
    type?: 'INCOME' | 'EXPENSE'
    monthlyLimit?: number | null
  }
): Promise<Category> {
  return api.patch(`/categories/${id}`, payload).then((r) => r.data)
}

export function deleteCategory(id: string): Promise<void> {
  return api.delete(`/categories/${id}`)
}
